import { Typography } from "@material-ui/core";
import React from "react";
import NameFields from "../../../Base/Components/NameFields";

export default function AdoptiveParentsInfoForm() {
  return (
    <div role="main">
      <Typography variant="h3" className="h3-header">
        Name of Adoptive Parent 1 at Time of Adoption
      </Typography>
      <NameFields namePrefix="adoptiveParent1" />
      <Typography variant="h3" className="h3-header">
        Name of Adoptive Parent 2 at Time of Adoption
      </Typography>
      <NameFields namePrefix="adoptiveParent2" />
    </div>
  );
}
